import { createContext, useCallback, useContext, useState, type ReactNode } from 'react'
import { cx } from '@/lib/cx'

type TipoToast = 'exito' | 'error' | 'info'
interface Toast {
  id: number
  tipo: TipoToast
  texto: string
}

const Contexto = createContext<((texto: string, tipo?: TipoToast) => void) | null>(null)

const estilos: Record<TipoToast, string> = {
  exito: 'bg-estado-cerrada-bg text-estado-cerrada-fg border-estado-cerrada-punto',
  error: 'bg-alerta-bloqueo-bg text-alerta-bloqueo-texto border-alerta-bloqueo-borde',
  info: 'bg-rey-900 text-white border-rey-900',
}

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toasts, setToasts] = useState<Toast[]>([])
  const avisar = useCallback((texto: string, tipo: TipoToast = 'info') => {
    const id = Date.now() + Math.random()
    setToasts((t) => [...t, { id, tipo, texto }])
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 5000)
  }, [])
  return (
    <Contexto.Provider value={avisar}>
      {children}
      <div
        aria-live="polite"
        className="pointer-events-none fixed bottom-4 right-4 z-50 flex flex-col gap-2"
      >
        {toasts.map((t) => (
          <div
            key={t.id}
            className={cx(
              'pointer-events-auto rounded-boton border px-4 py-3 text-label shadow-popover',
              estilos[t.tipo],
            )}
          >
            {t.texto}
          </div>
        ))}
      </div>
    </Contexto.Provider>
  )
}

// eslint-disable-next-line react-refresh/only-export-components
export function useAvisar() {
  const avisar = useContext(Contexto)
  if (!avisar) throw new Error('useAvisar fuera de ToastProvider')
  return avisar
}
